import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiChipOverrides = {
  defaultProps?: ComponentsProps['MuiChip'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiChip'];
  variants?: ComponentsVariants['MuiChip'];
}

function getMuiChipOverride(): MuiChipOverrides {
  return {
    styleOverrides: {
      root: {
        fontSize: "1.4rem",
        fontWeight: 400,
        lineHeight: "2rem",
        textTransform: "unset",
        paddingBlock: "var(--chip-padding-block)",
        paddingInline: "var(--chip-padding-inline)",
        borderWidth: "var(--chip-bdr-width)",
        borderStyle: "solid",
        borderRadius: "var(--chip-rounded)",
      },
      filledPrimary: {
        color: "var(--chip-clr-primary)",
        backgroundColor: "var(--chip-bg-primary)",
      },
      filledSecondary: {
        color: "var(--chip-clr-secondary)",
        backgroundColor: "var(--chip-bg-secondary)",
        ":hover": {
          color: "var(--chip-clr-secondary)",
          backgroundColor: "var(--chip-bg-secondary)",
        }
      },
      outlinedPrimary: {
        color: "var(--chip-clr-primary-outlined)",
        backgroundColor: "var(--chip-bg-primary-outlined)",
      },
      outlinedSecondary: {
        color: "var(--chip-clr-secondary-outlined)",
        backgroundColor: "var(--chip-bg-secondary-outlined)",
        borderColor: "var(--chip-bdr-secondary-outlined)",
      },
      deleteIcon: {
        color: "var(--chip-del-clr-secondary-outlined)",
        backgroundColor: "var(--chip-del-bg-secondary-outlined)",
        borderColor: "var(--chip-del-bdr-secondary-outlined)",
        ":hover": {
          color: "var(--chip-del-clr-secondary-outlined)",
          backgroundColor: "var(--chip-del-bg-secondary-outlined)",
          borderColor: "var(--chip-del-bdr-secondary-outlined)",
        }
      }
    }
  }
}

export default getMuiChipOverride;